import React, { useEffect, useState } from 'react'
import Question from '../../organisms/question/question';
import './sliderQuestion.scss'
import arrow from "../../../assets/chevron-down.svg"

interface SliderQuestionProps {
	formData: any;
	setData: any;
	questions: Array<any>;
	parentId: number;
}

const SliderQuestion2 = ({ formData, setData, questions, parentId }: SliderQuestionProps) => {

	const [questionCounter, setQuestionCounter] = useState(0);
	const [lastVisited, setLastVisited] = useState(0);
	const [canContinue, setCanContinue] = useState(false);

	const movePreviousQuestion = () => {
		setQuestionCounter((questionCounter - 1 < 0 ? 0 : questionCounter - 1))
	};

	const moveNextQuestion = async () => {
		if (questionCounter + 1 >= questions.length) {
			setCanContinue(true);
			if (!formData[parentId])
				setData(true, parentId);
			return;
		}
		setQuestionCounter(questionCounter + 1);
		if (questionCounter + 1 > lastVisited) {
			setLastVisited(questionCounter + 1);
		}

	};

	useEffect(() => {
		let counter = 0;
		questions.every((question, idx) => {
			if (!formData[question.id] || idx >= questions.length - 1) {
				counter = idx;
				setQuestionCounter(counter)
				setLastVisited(counter)

				if (counter >= questions.length - 1) {
					setData(true, parentId);
				}
				return false;
			}
			return true;
		})
	}, [])

	useEffect(() => {
		if (!formData[questions[questionCounter].id]) {
			return;
		}

		const timeout = setTimeout(() => {
			if (formData[questions[questionCounter].id] !== '') {
				moveNextQuestion();
			}
		}, 500);

		return () => {
			clearTimeout(timeout)
		};

	}, [formData])

	return (
		<div
			className="m-sliderQuestion-container"
		>
			<div className="m-sliderQuestion-container__index">
				{questionCounter + 1}
			</div>
			{questionCounter > 0 &&
				<div className="m-sliderQuestion-container__back-button" onClick={movePreviousQuestion}>
					<img src={arrow} alt="Volver a la pregunta anterior" />
				</div>
			}
			<Question
				question={questions[questionCounter]}
				value={formData[questions[questionCounter].id]}
				movePreviousQuestion={movePreviousQuestion}
				moveNextQuestion={moveNextQuestion}
				setData={setData}
				isSlider={true}
				sliderMaxValue={100}
				sliderValue={Math.round((questionCounter / (questions.length - (canContinue ? 1 : 0))) * 100)}
				formData={formData}
			/>
			{questionCounter < lastVisited &&
				<div className="m-sliderQuestion-container__next-button" onClick={moveNextQuestion}>
					<img src={arrow} alt="Volver a la pregunta anterior" />
				</div>
			}
		</div>
	)
}

export default SliderQuestion2